// extracted by mini-css-extract-plugin
export default {"filter-wrapper":"Filter_filter-wrapper__HtAht","filter":"Filter_filter__asygT","btn-section":"Filter_btn-section__6ofYH","suggest":"Filter_suggest__lzWzF"};